<template>
    <section class="notes-view">
        <h3>Notes</h3>
        <section v-if="notes.length > 0" class="notes">
            <note-view
                v-for="note in notes"
                :key="note.id"
                :message="note.message"
                :date="note.created_at"
                :user="note.user"/>
        </section>
        <section v-else class="notes">
            <app-alert>There are no notes yet.</app-alert>
        </section>

        <app-form class="notes-footer" @submit.native.prevent="submit">
            <app-input
                v-model="message"
                type="textarea"
                placeholder="Type something..."
                autosize/>
            <div class="notes-footer-button">
                <app-button :loading="isSaving" type="primary" native-type="submit">Add Note</app-button>
            </div>
        </app-form>
    </section>
</template>

<script>
import NoteView from './Note'
import Note from '@/store/models/Note'

export default {
    name: 'page-notes',
    components: {
        NoteView
    },
    props: ['studentUuid', 'classUuid'],
    data() {
        return {
            message: '',
            isSaving: false,
            notes: []
        }
    },
    mounted() {
        this.getNotes()
    },
    methods: {
        getNotes() {
            Note.$fetchAll({
                student_uuid: this.studentUuid,
                course_uuid: this.classUuid
            })
                .then(({ data }) => {
                    this.notes = data
                })
        },
        submit() {
            this.isSaving = true
            Note.$mutate({
                graphql: 'create',
                variables: {
                    message: this.message,
                    student_uuid: this.studentUuid,
                    course_uuid: this.classUuid
                }
            }).then(() => {
                this.message = ''
                this.isSaving = false
                this.getNotes()
            })
        }
    }
}
</script>

<style lang="stylus">
.notes
    padding-bottom: 70px

    .alert
        margin-top: 0px

.notes-footer
    position: absolute
    width: 100%
    background: #FFF
    padding: 15px 30px !important
    bottom: 0px
    left: 0px
    z-index: 10
    border-radius: 0px 0px 5px 5px
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.05)
    display: flex

    .notes-footer-button
        padding-left: 10px
        align-self: flex-end

    .el-textarea textarea
        min-height: 39px !important
</style>
